import React from 'react';

export default (props) => {
    return (
        <svg viewBox="0 0 60 60" {...props}>
            <path fill="#9698A0"
                  d="M30 58C14.536 58 2 45.464 2 30S14.536 2 30 2s28 12.536 28 28-12.536 28-28 28zm10.256-12.291c.648.535 1.23-.393.79-1.25C39.41 41.254 34.236 38.4 30 38.4c-4.234 0-9.41 2.853-11.047 6.06-.438.856.145 1.784.792 1.249 5.374-4.453 15.105-4.48 20.512 0zm-20.99-26.823c-2.32 0-4.2 2.713-4.2 6.067 0 3.348 1.88 6.066 4.2 6.066 2.32 0 4.2-2.718 4.2-6.066 0-3.354-1.88-6.067-4.2-6.067zm21.465 0c-2.319 0-4.2 2.713-4.2 6.067 0 3.348 1.881 6.066 4.2 6.066 2.32 0 4.2-2.718 4.2-6.066 0-3.354-1.88-6.067-4.2-6.067z"/>
        </svg>
    );
}